import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import ErrorBlock from '../../common/ErrorBlock';
import Button from '../../Button';
import SimpleInfoPopup from '../../common/SimpleInfoPopup';
import * as sendUserInvitation from '../../../redux/auth/send-invitation-req';
import {
  selectSendInvitationError,
  selectSendInvitationSucceed,
  selectSendInvitationPending,
} from '../../../redux/auth/selectors';
import styles from '../../Auth/index.styles';

const InvitationModal = ({
  formatMessage,
  opened,
  handleCloseInvitationModal,
  loginValue,
}) => {
  const dispatch = useDispatch();

  const sendInvitationSucceed = useSelector(selectSendInvitationSucceed);
  const sendInvitationPending = useSelector(selectSendInvitationPending);
  const isError = useSelector(selectSendInvitationError);

  const handleInvitation = () => {
    dispatch(sendUserInvitation.actions.send({ user: { login: loginValue } }));
  };

  return (
    <SimpleInfoPopup
      messageId="auth.sendOtp.inviteNotConfirmed"
      icon="icon-plane"
      opened={opened}
      width="rubber"
      withHeading={false}
      mobileFullScreen={false}
      dialogClassName="w-100"
      autoHeight
    >
      <If condition={isError}>
        <ErrorBlock
          errors={formatMessage({ id: 'errors.common' })}
          className={cn(styles.errorBlock, 'mt3')}
        />
      </If>
      <div className="df justify-center mt4">
        <Button
          onClick={handleInvitation}
          color="primary"
          raised
          disabled={sendInvitationPending || sendInvitationSucceed}
          className="w-50"
        >
          {formatMessage({ id: 'common.resendInvite' })}
        </Button>
        <Button
          onClick={handleCloseInvitationModal}
          color="primary"
          raised
          className="ml2 w-50"
        >
          {formatMessage({ id: 'submit.expiredToken' })}
        </Button>
      </div>
    </SimpleInfoPopup>
  );
};

InvitationModal.propTypes = {
  formatMessage: PropTypes.func,
  opened: PropTypes.bool,
  handleCloseInvitationModal: PropTypes.func,
  loginValue: PropTypes.string,
};

export default InvitationModal;



// WEBPACK FOOTER //
// ./src/components/OtpModal/InvitationModal/index.jsx